import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ImageComponent from 'atoms/Image';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import SampleArrowNext from 'organisms/OffersAndPromotions/Presentation/SampleArrowNext';
import SampleArrowPrev from 'organisms/OffersAndPromotions/Presentation/SampleArrowPrev';
import { useSelector } from 'react-redux';
import { UserOrderContext } from 'context/context';
import { RecommendProductSelect } from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/PdpAnalytics';
import {
  getPrice,
  getFullImagePath,
  isMobileDevice,
  getValueOrDefaultObject,
  isEmptyEvery,
  getPDPurl,
  getUserType,
  getBackgroundImageSrc,
  getBackgroundImagePath,
} from 'common/utilities/utils';

import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  CAROUSEL_RESPONSIVE_SETTINGS,
  LOCAL_STORAGE_KEYS,
  mockObject,
  ANALYTICS_SHARED_CONSTANTS,
  IMAGE_SIZE_CONSTANTS,
} from 'common/constants/SharedConstants';
import { cardsClass } from 'organisms/RecommendedComponent/AU/Presentation/RecommendedItem';
import {
  getCardTypeName,
  getProductImageClassName,
  getMenuProductHeader,
} from 'atoms/PlpMenuCard/Presentation/AU/PlpMenuCardViewComponent';
import { setPrevArrowCSS } from 'organisms/CartPage/Presentation/ReusableComponents/IndulgentAddOn';
const { PLP_PDP_DETAILS } = START_ORDER_CONSTANTS;
const { RECOMENDATIONS } = CART_PAGE_CONSTANTS;
const { SLIDES_TO_SCROLL, SLIDES_TO_SHOW } = RECOMENDATIONS;

export const settingsRecommendation = (onPrev, onNext, updateCurrent, updateRange) => {
  return {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    nextArrow: <SampleArrowNext clickNextCard={onNext} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrev} />,
    beforeChange: (current, next) => updateRange(next),
    afterChange: (current, prev) => updateCurrent(current),
    variableWidth: true,
    responsive: CAROUSEL_RESPONSIVE_SETTINGS,
  };
};

const RecommendationItem = ({ storeClosedData, recommendedProducts }) => {
  // Removing hidden products for the recommendations list
  const noHiddens = recommendedProducts?.filter?.(i => !i.isHidden);

  return (
    Boolean(noHiddens?.length) && (
      <div className='recommended-container pdp-recommendations'>
        <div className='recommendedCard-container recommendedCard-container-au'>
          <div className='recommendedContainerHeader-items'>
            <div className='recommendedContainer-header cart-recomendations-title'>
              <span className='main-header'>
                {translateWithI18Next(CART_PAGE_CONSTANTS.EMPTY_CART.SUGGESTION_TEXT)}
              </span>
            </div>
          </div>
          <RecommendationList recommendRules={noHiddens} storeClosedData={storeClosedData} />
        </div>
      </div>
    )
  );
};

const RecommendationCard = ({ tenantData, storeClosedData, item, userParams, index }) => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const cardType = 'medium';
  const { tenantReducer } = useSelector(data => {
    return {
      tenantReducer: getValueOrDefaultObject(data.tenantReducer),
    };
  });
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const storeInfo = dispositionNew ? dispositionNew.store : mockObject;
  const cardId = item.id;
  const categoryId = null;
  const { currencyConversionFactor = 1, currencySymbol = '' } = tenantData;
  const { name = '', availability, imageName, categoryUrl: category_url, id } = getValueOrDefaultObject(item);
  const history = useHistory();
  const catalogs =
    (storeInfo?.summary?.menu?.catalogs?.length && storeInfo?.summary?.menu?.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';
  const { componentOptions = {} } = tenantData;
  const { PlpProductCard = {} } = componentOptions;
  const { allowClickOnProductCard = false } = PlpProductCard;
  const flatResponse = useSelector(({ menuReducer: { flatResponse = {} } = {} }) => flatResponse || {});
  const { cartData = {} } = useSelector(data => data?.cartReducer || {});
  const { discountLines = [] } = cartData || {};
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { headerData: { pdpBackgroundImage = {} } = {} } = useSelector(state =>
    getValueOrDefaultObject(state?.marketConfigReducer?.response),
  );
  const pdpBackgroundImageData = getBackgroundImagePath(pdpBackgroundImage);
  const [imageContainerSize, setImageContainerSize] = useState(0);
  const { RECOMMENDED_ITEM } = IMAGE_SIZE_CONSTANTS;
  const { ITEM_IMAGE_HEIGHT_MOBILE, ITEM_IMAGE_WIDTH_MOBILE, ITEM_IMAGE_HEIGHT_DESKTOP, ITEM_IMAGE_WIDTH_DESKTOP } =
    RECOMMENDED_ITEM;

  const getImageSize = () => {
    const isMobileSize = isMobileDevice(window.innerWidth);
    if (isMobileSize) {
      return { height: ITEM_IMAGE_HEIGHT_MOBILE, width: ITEM_IMAGE_WIDTH_MOBILE };
    }
    return { height: ITEM_IMAGE_HEIGHT_DESKTOP, width: ITEM_IMAGE_WIDTH_DESKTOP };
  };
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
    setImageContainerSize(getImageSize());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const onCardClickHandler = (e, productId, customizable, category_id, productInfo, productIndex) => {
    e.preventDefault();
    e.stopPropagation();
    let ProductDetails = {
      category_id,
      customizable,
      productId,
      isFromPlp: true,
      productInfo: productInfo,
      catalogName: catalogs,
    };
    const { url: prod_url } = flatResponse?.productMapByItemId?.[id] ?? {};
    userOrderStateDispatch({
      value: ProductDetails,
      type: PLP_PDP_DETAILS,
    });
    const { localized = false, loggedIn = false } = getValueOrDefaultObject(userParams);
    const userType = getUserType(localized, loggedIn);
    const len = discountLines && discountLines?.length - 1;
    const discountLinesObj = discountLines && discountLines[len];
    const { couponCode = '', amount = '' } = discountLinesObj || {};

    const itemsList = [
      {
        item_name: name,
        item_id: id,
        price: getPrice(availability[0], tenantData?.currencyConversionFactor),
        coupon: couponCode,
        discount: amount,
        currency: ANALYTICS_SHARED_CONSTANTS.AUD,
        item_category: category_url && category_url[0],
        item_list_name: ANALYTICS_SHARED_CONSTANTS.PDP_UPSELL,
        item_list_id: ANALYTICS_SHARED_CONSTANTS.SR_VALUE,
        index: productIndex,
        quantity: 1,
      },
    ];
    RecommendProductSelect(userType, itemsList);
    userOrderStateDispatch({
      type: MENU_PDP_PAGE_CONSTANTS.RECOMMENDED_SECTION_ITEM_CLICK,
      isFromRecommendedSectionItemClick: true,
    });
    history.push({
      pathname: getPDPurl(category_url, prod_url, history?.location?.pathname),
    });
    localStorage.setItem(LOCAL_STORAGE_KEYS.PRODUCT_DETAILS, JSON.stringify(ProductDetails));
  };
  const plpBackgroundStyle = () =>
    getBackgroundImageSrc(pdpBackgroundImageData, imageContainerSize.width, imageContainerSize.height);

  const productImageComponentCart = () => {
    return (
      <ImageComponent
        data-testid='product-image'
        className={getProductImageClassName(isMobile, cardType)}
        defaultPath={getFullImagePath(null, tenantData, true)}
        srcFile={imageName[0].value}
        onClick={event =>
          allowClickOnProductCard &&
          onCardClickHandler(
            event,
            cardId,
            item.customizable,
            categoryId,
            {
              productName: item.dname,
              productImage: imageName,
              productPrice: getPrice(availability[0], tenantData?.currencyConversionFactor),
            },
            index,
          )
        }
        alt=''
      />
    );
  };

  return (
    <div className={cardsClass()}>
      <div className={getCardTypeName(isMobile, cardType, allowClickOnProductCard)}>
        <div style={plpBackgroundStyle()} className='product-image-parent-container'>
          {productImageComponentCart()}
        </div>
        <div
          className='menu-card-content'
          data-testid='menu-card-content'
          onClick={e =>
            allowClickOnProductCard &&
            onCardClickHandler(
              e,
              cardId,
              item.customizable,
              categoryId,
              {
                productName: item.dname,
                productImage: imageName,
                productPrice: getPrice(availability[0], tenantData?.currencyConversionFactor),
              },
              index,
            )
          }
        >
          <div className={getMenuProductHeader(isMobile)}>
            {name}
            <div className={!isMobile ? 'Price-and-KJ-info' : 'small-price-and-KJ-info'}>
              <div className={!isMobile ? 'medium-menu-price-and-KJ' : 'small-menu-price-and-KJ'}>
                {item?.content?.caloricValue} {tenantData?.kilojoule}
                &nbsp;&nbsp;{translateWithI18Next(TRANSLATE_MAPPING_KEY?.SERVES)} {item?.content?.serves}
              </div>
              <div className='medium-menu-vegOrNonVeg cartItem-serves'></div>
            </div>
            <div className='medium-menu-product-price'>
              <span>
                {currencySymbol}
                {getPrice(availability[0], currencyConversionFactor)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const RecommendationList = ({ recommendRules, storeClosedData }) => {
  recommendRules = recommendRules?.filter(rule => rule.name !== undefined);
  const tenantData = useSelector(state => state?.tenantReducer);
  const userParams = useSelector(data => data?.appStateReducer?.userStatus);
  const [currentSlide, updateCurrentSlide] = useState(0);
  const [rangeValue, updateRangeValue] = useState(0);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);
  const carousal = React.useRef(null);

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  const onUpdateRange = e => {
    updateRangeValue(e.target.value);
    carousal.current.slickGoTo(e.target.value);
    setPrevArrowCSS(e.target.value);
  };

  /* OnClicking Previous Arrow Button */
  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
    setPrevArrowCSS(currentSlide - SLIDES_TO_SCROLL);
    return true;
  };

  const onNextCard = () => {
    if (currentSlide < recommendRules.length - 1) {
      let updatedCurrentSlide = 0;
      if (currentSlide + SLIDES_TO_SCROLL > recommendRules.length - SLIDES_TO_SHOW - 1) {
        updatedCurrentSlide = recommendRules.length - SLIDES_TO_SHOW;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      setPrevArrowCSS(updatedCurrentSlide);
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
    return true;
  };

  return (
    <div className='cart-recomendations-list-container-root recommendedCard-list'>
      <div className='cart-recomendations-list-container recommendedCarousal-list'>
        {recommendRules.length && (
          <CarauselComp
            settings={settingsRecommendation(onPrevCard, onNextCard, updateCurrentSlide, updateRangeValue)}
            carousalRef={carousal}
          >
            {recommendRules.map((item, index) => {
              return (
                <RecommendationCard
                  tenantData={tenantData}
                  storeClosedData={storeClosedData}
                  item={item}
                  userParams={userParams}
                  index={index}
                />
              );
            })}
          </CarauselComp>
        )}
      </div>
      {!isMobile && recommendRules.length > SLIDES_TO_SHOW && (
        <div className='cart-recomendations-slideContainer'>
          <input
            type='range'
            data-testid='range-input'
            value={rangeValue}
            id='myRange'
            onChange={onUpdateRange}
            min='0'
            max={recommendRules.length - SLIDES_TO_SHOW}
            className='cart-recomendations-slider'
          />
        </div>
      )}
    </div>
  );
};

export default RecommendationItem;
